const isProd = typeof window !== 'undefined' && window.location.hostname && window.location.hostname !== 'localhost';
const NODE_BASE = isProd
  ? (typeof window !== 'undefined' ? window.location.origin : '')
  : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000');

export const SEND_EMAIL_URL_NODE = `${NODE_BASE}/api/send-email`;
export const SEND_EMAIL_URL_PHP = isProd && typeof window !== 'undefined'
  ? `${window.location.origin}/api/send-email.php`
  : null;
